import React from 'react'
import cn from 'classnames'
import classes from './SkeletonLoader.module.scss'

export const SkeletonLoader = ({
  width,
  height,
  className = '',
  color = 'light',
}: {
  width?: number
  height: number
  className?: string
  color?: 'light' | 'dark'
}) => (
  <span
    className={cn(classes.loading, className, {
      [classes.dark]: color === 'dark',
    })}
    style={{ ...(width && { width }), height }}
  />
)
